var map = {
	"./double-bed.svg": "06d7",
	"./footer_icons.png": "3d35",
	"./logo-los-cocos.png": "f6fe",
	"./los-cocos-img-bg.png": "1363",
	"./los-cocos-iso-footer.png": "a032",
	"./los-cocos-room-header-2-x.png": "4f71",
	"./room_1.png": "3480",
	"./room_2.png": "34f9",
	"./room_3.png": "6246",
	"./stepper.png": "81db"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";